import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

import { MyOidcAuthService } from './my-oidc-auth.service';

@Injectable()
export class MyOidcForcedLoginGuard implements CanActivate {


  constructor(
    private authService: MyOidcAuthService,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.authService.isDoneLoading$.pipe(
      filter(isDone => isDone),
      switchMap(_ => this.authService.isAuthenticated$),
      tap(isAuthenticated => {
        console.log(`tap canActivate`);
        if (isAuthenticated) {
          console.log('already authenticaed');
          return true;
        }
        console.log('calling login');
        this.authService.login(state.url);
        return false;
      }),
    );
  }
}
